import "./style.css";
import BarbellImage from "../../../images/bunker.jpg";

function Main(props: any) {
  const { isDesktop, gymName, mainTitle } = props;
  return (
    <div
      className="Main"
      style={{
        background: `linear-gradient(
            rgba(240, 240, 240, 0.144),
            rgba(255, 255, 255, 0.336)
          ),
          url(${BarbellImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        paddingTop: isDesktop ? "140px" : 0,
        wordBreak: "break-word",
      }}
    >
      <div className="main-container">
        <h1
          style={{ fontSize: isDesktop ? "95px" : "60px" }}
          className="main-title"
          id="home"
        >
          {gymName}
        </h1>
        <p style={{ fontSize: isDesktop ? "80px" : "50px" }}>{mainTitle}</p>
      </div>
    </div>
  );
}

export default Main;
